import axios from 'axios'
import router from '@/router'

axios.defaults.withCredentials=true;
export function request(config){
  const instance = axios.create({
    baseURL:'http://info.itbx.cc/',
    timeout:15000,
    withCredentials:true,
  })

  instance.interceptors.response.use(res =>{
  	return res
  },err => {
  	if(err.response.status==307){
  		router.replace('/login')
  		err.response.status=301
  	}
  })
  return instance(config)
}
